<script>
    import messages from './messages';
    import {yandexReachGoal} from '../parts/yandexReachGoal';


    export default {
        data() {
            return {
                msg: messages,

                formState: {},

                form: {
                    type      : messages.typeOfExpertize[0],
                    objName   : null,
                    objAddress: null,
                    person    : null,
                    telephone : null,
                    email     : null,
                    message   : null,
                },

                formSending : false,
                formSent    : false,
                formDisabled: false,

                formErrorMessage: '',
            };
        },

        mounted() {
            console.log('State:', this.formState);
        },

        computed: {
            submitClass() {
                return {
                    'is-loading': this.formSending,
                };
            },
            buttonText() {
                if (!this.formState.$submitted) {
                    return messages.buttonTextDefault2;
                }
                if (this.formState.$invalid) {
                    return this.msg.buttonTextRequireAll;
                } else {
                    if (this.formSending) {
                        return messages.buttonTextSending;
                    } else {
                        if (this.formSent) {
                            return messages.buttonTextSent;
                        } else {
                            return messages.buttonTextDefault2;
                        }
                    }

                }
            },
            showResetButton() {
                return this.formSent;
            },
        },

        methods: {
            send(event) {
                if (this.formState.$invalid) {
                    console.log('(!) Form isn\'t valid');
                    return;
                }

                console.log('Form is valid');

                let data = new FormData();

                data.append('hash', window.__token__);
                data.append('Type', this.form.type);
                data.append('ObjName', this.form.objName);
                data.append('ObjAddress', this.form.objAddress);
                data.append('Person', this.form.person);
                data.append('Telephone', this.form.telephone);
                // data.append('Email', '');
                data.append('Mail', this.form.email);
                data.append('Message', this.form.message);

                this.formSending      = true;
                this.formDisabled     = true;
                this.formErrorMessage = '';

                let url    = event.target.action + '?tmpl=component_ajax&send_mails=1&task_of=201';
                // url        = '/?send_mails=1&task_of=201';
                let method = event.target.method;

                console.log(url, method);

                setTimeout(() => {
                    $.ajax({
                        url,
                        method,
                        data,
                        dataType: 'json',
                        processData: false,
                        contentType: false,

                        success: (data) => {
                          if (data.status) {
                            yandexReachGoal('btn-order-send');
                            this.formSending = false;
                            this.formSent    = true;
                          } else {
                            this.formSending      = false;
                            this.formDisabled     = false;
                            this.formErrorMessage = data.message;
                            console.error('ERROR!', data.debug);
                          }
                        },
                        error  : error => {
                            // yandexReachGoal('btn-order-error');
                            this.formSending      = false;
                            this.formDisabled     = false;
                            this.formErrorMessage = error.status + ' ' + error.statusText;
                            console.error('ERROR!', error);
                        },
                    });
                }, 1500);
            },

            resetForm() {
                this.formState._reset();
                this.form = {
                    type      : messages.typeOfExpertize[0],
                    objName   : null,
                    objAddress: null,
                    person    : null,
                    telephone : null,
                    email     : null,
                    message   : null,
                };

                this.formSending  = false;
                this.formSent     = false;
                this.formDisabled = false;

                this.formErrorMessage = '';
            },

            formGroupState(fieldState) {
                return {
                    invalid: fieldState && (this.formState.$submitted || fieldState.$touched) && fieldState.$invalid,
                };
            },
        },
    };
</script>

<template>
    <div class="form">
        <vue-form
            action="/ajax/order201" method="post"
            :state="formState"
            @submit.prevent="send"
        >
            <div class="form__section pt">
                <div class="form__group">
                    <label class="form__label" for="view-of-exp">{{ msg.fields.typeOfExpertize }}</label>
                    <select class="form-select"
                        v-model="form.type"
                        name="Type"
                        :data-field-name="msg.fields.typeOfExpertize"
                        :disabled="formDisabled"
                        id="view-of-exp">
                        <option v-for="item in msg.typeOfExpertize" v-html="item"></option>
                    </select>
                </div>
                <validate class="form__group" :class="formGroupState(formState.ObjName)">
                    <div class="form__label">{{ msg.fields.objectName }}</div>
                    <input class="form-input"
                        v-model="form.objName"
                        required
                        name="ObjName"
                        :data-field-name="msg.fields.objectName"
                        :disabled="formDisabled"
                        placeholder=""
                        type="text" />
                    <div class="form__error">{{ msg.fieldRequired }}</div>
                </validate>
                <validate class="form__group" :class="formGroupState(formState.ObjAddress)">
                    <div class="form__label">{{ msg.fields.objectAddress }}</div>
                    <input class="form-input"
                        v-model="form.objAddress"
                        required
                        name="ObjAddress"
                        :data-field-name="msg.fields.objectAddress"
                        :disabled="formDisabled"
                        placeholder=""
                        type="text" />
                    <div class="form__error">{{ msg.fieldRequired }}</div>
                </validate>
            </div>
            <div class="form__section pt">
                <validate class="form__group" :class="formGroupState(formState.ConFace)">
                    <div class="form__label">{{ msg.fields.person }}</div>
                    <input class="form-input"
                        v-model="form.person"
                        required
                        name="ConFace"
                        :data-field-name="msg.fields.person"
                        :disabled="formDisabled"
                        placeholder=""
                        type="text" />
                    <div class="form__error">{{ msg.fieldRequired }}</div>
                </validate>
                <validate class="form__group" :class="formGroupState(formState.Phone)">
                    <div class="form__label">{{ msg.fields.telephone }}</div>
                    <input class="form-input"
                        v-model="form.telephone"
                        required
                        name="Phone"
                        :data-field-name="msg.fields.telephone"
                        :disabled="formDisabled"
                        placeholder=""
                        type="text" />
                    <div class="form__error">{{ msg.fieldRequired }}</div>
                </validate>
                <validate class="form__group" :class="formGroupState(formState.Email)">
                    <div class="form__label">{{ msg.fields.email }}</div>
                    <input class="form-input"
                        v-model="form.email"
                        required
                        name="Email"
                        :data-field-name="msg.fields.email"
                        :disabled="formDisabled"
                        placeholder=""
                        type="email" />
                    <div class="form__error" v-if="formState.Email && !formState.Email.$error.email">{{
                        msg.fieldRequired }}
                    </div>
                    <div class="form__error" v-if="formState.Email && formState.Email.$error.email">{{
                        msg.fieldInvalidEmail }}
                    </div>
                </validate>
            </div>
            <validate class="form__group" :class="formGroupState(formState.Message)">
                <div class="form__label">{{ msg.fields.message }}</div>
                <textarea class="form-textarea"
                    v-model="form.message"
                    required
                    name="Message"
                    :data-field-name="msg.fields.message"
                    :disabled="formDisabled"
                    placeholder=""></textarea>
                <div class="form__error">{{ msg.fieldRequired }}</div>
            </validate>

            <div class="form__group" v-if="formErrorMessage">
                <div class="alert">
                    Произошла ошибка: «{{formErrorMessage}}»<br>
                    Попробуйте повторить отправку позже
                </div>
            </div>

            <div class="form__group form__group_buttons text-right">
                <span class="form__reset" v-if="showResetButton" @click="resetForm()">
                    Очистить форму и оформить еще один заказ
                </span>
                <input class="btn btn_primary btn_large"
                    :class="submitClass"
                    :disabled="formDisabled"
                    :value="buttonText"
                    type="submit">
            </div>
            <div class="form__done form__done_static" :hidden="!formSent">
                <b>Ваш заказ принят</b>
                <i>Мы свяжемся с вами в ближайшее время</i>
            </div>
        </vue-form>
    </div>
</template>
